import { MenuItem2Props } from "@blueprintjs/popover2";
import { ItemPredicate } from "@blueprintjs/select";
import { Attributes } from "react";

import { ItemRendererExtendedProps } from "./components/item";
import { SelectItem } from "./types";

/** ======== Filter Item ======== */
export const filterItem: ItemPredicate<SelectItem> = (query, item, _index, exactMatch) => {
  const normalizedTitle = item.label.toLowerCase();
  const normalizedQuery = query.toLowerCase();

  if (exactMatch) {
    return normalizedTitle === normalizedQuery;
  } else {
    return `${normalizedTitle}`.indexOf(normalizedQuery) >= 0;
  }
};

/** ======== Get Item Props ======== */
export const getItemProps = (
  option: SelectItem,
  { handleClick, modifiers, ref, selected }: ItemRendererExtendedProps
): MenuItem2Props & Attributes => {
  return {
    active: modifiers.active,
    disabled: modifiers.disabled,
    elementRef: ref,
    key: option.id,
    text: option.label,
    onClick: handleClick,
    roleStructure: "listoption",
    selected,
  };
};
